import React from 'react';

const AboutPage = () => {
  return (
    <div className="bg-[#fdfdfd] mt-10 py-12 px-6">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-5xl font-extrabold text-[#4CAF50] mb-6">
          About Us
        </h1>
        <p className="text-xl text-[#7b7b7b] mb-8 max-w-3xl mx-auto">
          <strong className="text-[#4CAF50]">Himanshu Salary Corner</strong> is a trusted name with over 25 years of experience serving employees in various sectors. We specialize in providing accurate calculations and financial documentation related to salaries, pensions, benefits, pay commission fixations, promotion fixations, and more. Our commitment to precision and reliable service has made us a go-to resource for individuals seeking expert assistance with their financial Calculations.
        </p>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-3xl font-semibold text-[#353535] mb-4">Our Expertise</h2>
            <p className="text-lg text-[#7b7b7b] mb-6">
            Himanshu Salary Corner is a trusted name with over 25 years of experience serving employees in various sectors. We specialize in providing accurate calculations and financial documentation related to salaries, pensions, benefits, pay commission fixations, promotion fixations, and more. Our commitment to precision and reliable service has made us a go-to resource for individuals seeking expert assistance with their financial Calculations.
            </p>
            </div>

          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-3xl font-semibold text-[#353535] mb-4">Why Choose Us</h2>
            <p className="text-lg text-[#7b7b7b] mb-6">
            With over 25 years of experience across Maharashtra, we have built a reputation for accuracy, reliability, and expertise. Our commitment is to provide employees with the most up-to-date information and calculations, ensuring they are fully informed of their entitlements. We focus on delivering precise and timely services to meet the financial needs of our clients.       </p>
          </div>
        </div>

        <div className="mt-10">
          <h2 className="text-3xl font-semibold text-[#353535] mb-6">Our Mission</h2>
          <p className="text-lg text-[#7b7b7b] max-w-3xl mx-auto">
          Our mission is to empower employees by offering accurate and timely resources for salary-related issues. We strive to simplify complex pay structures, ensuring employees can make informed decisions about their finances and benefits.
          </p>
        </div>

        <div className="mt-10" style={{ backgroundColor: '#4CAF50', color: '#fff', padding: '2rem' }}>
          <h2 className="text-3xl font-semibold mb-4">Get In Touch</h2>
          <p className="text-lg">
          We're here to help you navigate the complexities of salary structures. Reach out to us for expert assistance and insights!          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
